/* eslint-disable react/forbid-prop-types */
/* eslint-disable camelcase */
/* eslint-disable */
import PropTypes from "prop-types";
import CardData from "components/CardData";
import { MapPin } from "react-feather";
import { useMap } from "context/mapContext";
import handleZoom from "utils/handleZoom";

function BaseCard(props) {
  const { actions, cardDetails } = props;
  const [map] = useMap();
  const { view, graphicsLayer } = map;

  const handleZoomClick = () => {
    handleZoom([cardDetails], view, graphicsLayer);
  };
  return (
    <div className="base_card">
      <CardData cardDetails={cardDetails} />

      <div
        className={`base_card__actions base_card__actions${
          cardDetails.IS_PRINTABLE ? "--2" : "--1"
        }`}
      >
        {cardDetails.IS_PRINTABLE ? (
          <>
            <button
              type="button"
              className="btn btn--primary"
              onClick={actions.actionA.bind(this, cardDetails)}
            >
              طلب اصدار مخطط
            </button>
            <button
              type="button"
              className="btn btn--primary--light"
              onClick={actions.actionB.bind(this, cardDetails)}
            >
              طباعة نسخة تجريبية
            </button>
          </>
        ) : (
          <button type="button" className="btn btn--gray pointer-events-none">
            لا يمكن اصدار مخطط لهذه الأرض الرجاء التواصل مع سلطة اقليم البتراء
          </button>
        )}
        <button
          onClick={handleZoomClick}
          type="button"
          className="btn btn--primary--light"
        >
          <MapPin fontSize={20} />
        </button>
      </div>
    </div>
  );
}

BaseCard.propTypes = {
  actions: PropTypes.object.isRequired,
  cardDetails: PropTypes.object.isRequired,
};

export default BaseCard;
